module.exports = __webpack_public_path__ + "static/img/tr.63e4c16c.svg";